<template>
    <section class="wetested">
        <h3 v-if="reviews.length > 0" class="my-4">{{ $t('productDetail.tabs.weTestedText') }}</h3>

        <ReviewOverview v-if="reviews.length" id="review-list" :review-list-data="reviews" />

        <ReviewDetail
            v-show="isReviewShown"
            v-if="reviewDetail.id"
            ref="reviewDetail"
            :review="reviewDetail"
            :all-review-images="allReviewImages"
        />
    </section>
</template>

<script lang="ts">
import ReviewDetail from '~/components/objects/ReviewClub/Detail/ReviewDetail.vue'
import Review from '~/models/ReviewClub/Review'
import QuestionBlockImage from '~/models/ReviewClub/QuestionBlockImage'
import ReviewOverview from '~/components/elements/ReviewOverview.vue'

const MAX_IMAGES_PER_BLOCK = 2

export default {
    components: {
        ReviewDetail,
        ReviewOverview,
    },

    props: {
        reviews: {
            type: Array as PropType<Review[]>,
            default: () => [],
        },
    },

    data() {
        return {
            reviewDetail: {} as Review,
            allReviewImages: [] as QuestionBlockImage[],
            isReviewShown: false,
        }
    },

    mounted() {
        console.log('show review detail 2')
        useNuxtApp().$bus.$off('showReviewDetailWeTested')
        useNuxtApp().$bus.$on('showReviewDetailWeTested', async (reviewId: number | null): Promise<void> => {
            this.isReviewShown = true

            if (reviewId === null) {
                return
            }

            await this.openDetailReview(reviewId)

            setTimeout(() => {
                this.$refs.reviewDetail?.$el?.scrollIntoView?.({ behavior: 'smooth' })
            }, 100)
        })

        const route = useRoute()
        const reviewId = parseInt(route.query.reviewId as string)
        if (reviewId > 0) {
            useNuxtApp().$bus.$emit('showReviewDetail', reviewId)
            useNuxtApp().$bus.$emit('showReviewDetailWeTested', reviewId)
        }

        useNuxtApp().$bus.$on('closeReview', (): void => {
            this.isReviewShown = false
            window.scrollTo({ top: 500, behavior: 'smooth' })

            const location = {
                path: this.$route.path,
                query: {},
            }

            this.$router.push(location)
        })
    },

    methods: {
        async openDetailReview(id: number | null): Promise<void> {
            if (id === null) {
                return
            }

            const reviewDetail = (await this.$repository.getProductReviewDetail(id)) as Review

            if (reviewDetail.questionBlocks) {
                const questionBlockImages = reviewDetail.questionBlocks.map(({ images }) => images)
                const totalImageCount = questionBlockImages.reduce((carry, { length }) => carry + length, 0)

                const imageCountPerBlock = Math.min(Math.round(totalImageCount / questionBlockImages.length), MAX_IMAGES_PER_BLOCK)
                const imageStack: QuestionBlockImage[] = []
                this.allReviewImages = []

                if (totalImageCount > 0 && imageCountPerBlock > 0) {
                    for (let i = 0; i < questionBlockImages.length; ++i) {
                        const questionBlockImageList = [...questionBlockImages[i]]
                        this.allReviewImages.push(...questionBlockImageList.flat(Infinity))

                        if (questionBlockImageList.length > imageCountPerBlock) {
                            reviewDetail.questionBlocks[i].images = questionBlockImageList.slice(0, imageCountPerBlock)
                            imageStack.push(...questionBlockImageList.slice(imageCountPerBlock))

                            continue
                        }

                        if (i === questionBlockImages.length - 1) {
                            reviewDetail.questionBlocks[i].images.push(...imageStack.slice(0, MAX_IMAGES_PER_BLOCK))
                        } else {
                            const imageCountToFill = imageCountPerBlock - questionBlockImageList.length

                            reviewDetail.questionBlocks[i].images.push(...imageStack.splice(0, imageCountToFill))
                        }
                    }
                }

                this.reviewDetail = reviewDetail
            }
        },
    },
}
</script>
